import React from "react"

interface SubFolderArrowProps {
  open: boolean
}

const SubFolderArrow: React.FC<SubFolderArrowProps> = ({ open }) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: open ? "rotate(180deg)" : "rotate(0deg)",
        transition: "transform 0.3s ease",
      }}
    >
      <path
        d="M2.82721 5.62194C3.02201 5.42323 3.32684 5.40517 3.54165 5.56775L3.60319 5.62194L7.99984 10.107L12.3965 5.62194C12.5913 5.42323 12.8961 5.40517 13.1109 5.56775L13.1725 5.62194C13.3673 5.82065 13.385 6.13159 13.2256 6.3507L13.1725 6.41348L8.38782 11.2941C8.19302 11.4928 7.8882 11.5108 7.67339 11.3483L7.61185 11.2941L2.82721 6.41348C2.61293 6.1949 2.61293 5.84052 2.82721 5.62194Z"
        fill="#D5D5D5"
      />
    </svg>
  )
}

export default SubFolderArrow
